import * as yup from 'yup';
import {
  MAX_SIZE,
  validateFile,
} from '@components/Queries/hooks/useAttachments';

export const querySchema = yup.object().shape({
  types: yup
    .array()
    .transform((value: string[]) =>
      (value || [])
        .map((v: string) => (v || '').trim())
        .filter((v: string) => v.length > 0)
    )
    .of(yup.string().required('Query type must not be empty'))
    .min(1, 'Query type is required')
    .required(),
  recipients: yup
    .array()
    .of(yup.string().required())
    .min(1, 'At least one recipient is required')
    .required()
    .default([]),
  queryText: yup.string().required('Query text is required'),
  attachments: yup
    .array()
    .of(yup.mixed<File>().required())
    .max(3, 'Maximum 3 attachments allowed')
    .test('maxSize', 'File size must not exceed 5 MB', files => {
      const arr = files || [];
      return arr.every((file: File) => file.size <= MAX_SIZE);
    })
    .test('unsupportedFormats', (files, ctx) => {
      const unsupported = (files || []).filter(
        (file: File) => !validateFile(file)
      );
      if (unsupported.length === 0) {
        return true;
      }
      return ctx.createError({
        message:
          'Unsupported file format. Only .jpg, .jpeg, .png, .pdf, .doc, .docx files are allowed',
      });
    })
    .required()
    .default([]),
});
